// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_homepage_header__r9oVG,
.header_homepage_container__upHY-,
.header_homepage_nav__6Fv7q {
    box-shadow: none;
    border: none;
}

.header_homepage_header__r9oVG {
    width: 100%;
    background-color: #00000000;
    top: 0;
    left: 0;
    z-index: 1000;
}

.header_homepage_container__upHY- {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    max-width: 100%;
    margin: auto;
}

.header_homepage_logo__7PTq6 {
    width: 120px;
}

.header_homepage_nav__6Fv7q {
    float: right;
    align-items: center;
    margin-top: 15px;
}

.header_homepage_nav__6Fv7q ul {
    display: flex;
    margin-right: 20px;
}

.header_homepage_nav_bar_button__2lzgU {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    text-decoration: none;
    margin-right: 20px;
    position: relative;
    border: none;
    background: none;
    transition: color 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
}

.header_homepage_nav_bar_button__2lzgU:focus:after,
.header_homepage_nav_bar_button__2lzgU:hover:after {
    width: 100%;
    left: 0%;
}

.header_homepage_nav_bar_button__2lzgU:after {
    content: "";
    pointer-events: none;
    bottom: -2px;
    left: 50%;
    position: absolute;
    width: 0%;
    height: 2px;
    background-color: #ffffff;
    transition: width 400ms cubic-bezier(0.25, 0.8, 0.25, 1), left 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
}

.header_homepage_nav_bar_button__2lzgU a {
    color: inherit;
    text-decoration: none;
    display: inline-block;
}

@media (max-width: 768px) {
    .header_homepage_container__upHY- {
        padding: 10px 15px;
    }

    .header_homepage_logo__7PTq6 {
        margin-top: 5px;
        width: 80px;
    }

    .header_homepage_nav__6Fv7q ul {
        display: none;
        position: absolute;
        right: -15px;
        width: 200px;
        background-color: #ffffffdd;
        flex-direction: column;
        list-style: none;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        margin-left: 0;
    }

    .header_homepage_nav__6Fv7q ul.header_homepage_showMenu__vmxeO {
        display: flex;
    }

    .header_homepage_nav_bar_button__2lzgU {
        margin: 10px 15px;
        font-size: 14px;
        color: #1e1e1e;
        transition: background-color 0.3s, color 0.3s;
        padding: 8px 15px;
        border-radius: 8px;
    }

    .header_homepage_nav_bar_button__2lzgU a {
        color: inherit;
    }

    .header_homepage_nav_bar_button__2lzgU:hover,
    .header_homepage_nav_bar_button__2lzgU:focus {
        background-color: #f4f4f4;
        color: #1e1e1e;
    }

    .header_homepage_hamburger__HiVS6 {
        height: 40px;
        width: 40px;
        transform: 0.2s;
        position: relative;
        cursor: pointer;
    }

    .header_homepage_hamburger__HiVS6 input[type='checkbox'] {
        position: absolute;
        opacity: 0;
        height: 100%;
        width: 100%;
        cursor: pointer;
    }

    .header_homepage_line__HJ\\+Xj {
        transition: 0.5s;
        stroke-width: 4px;
        stroke: #ffffff;
    }

    .header_homepage_lineTop__1H3YV {
        stroke-dasharray: 40 40;
        stroke-dashoffset: 25;
    }

    .header_homepage_lineBottom__31-mP {
        stroke-dasharray: 40 40;
        stroke-dashoffset: 60;
    }

    .header_homepage_lineMid__-FPAn {
        stroke-dasharray: 40 40;
    }

    .header_homepage_hamburger__HiVS6 input[type='checkbox']:checked+svg .header_homepage_line__HJ\\+Xj {
        stroke: #ffffff;
    }

    .header_homepage_hamburger__HiVS6 input[type='checkbox']:checked+svg .header_homepage_lineTop__1H3YV {
        stroke-dashoffset: 0;
        transform-origin: left;
        transform: rotateZ(45deg) translate(-7px, -5px);
    }

    .header_homepage_hamburger__HiVS6 input[type='checkbox']:checked+svg .header_homepage_lineMid__-FPAn {
        stroke-dashoffset: 40;
    }

    .header_homepage_hamburger__HiVS6 input[type='checkbox']:checked+svg .header_homepage_lineBottom__31-mP {
        stroke-dashoffset: 0;
        transform-origin: left;
        transform: rotateZ(-45deg) translate(-5px, 5px);
    }
}

@media (min-width: 769px) {
    .header_homepage_container__upHY- {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .header_homepage_logo__7PTq6 {
        order: 1;
    }

    .header_homepage_nav__6Fv7q {
        order: 2;
    }

    .header_homepage_nav__6Fv7q ul {
        display: flex;
        justify-content: flex-end;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Site/Header_HomePage/header_homepage.module.css"],"names":[],"mappings":"AAAA;;;IAGI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,MAAM;IACN,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,wDAAwD;AAC5D;;AAEA;;IAEI,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,qGAAqG;AACzG;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,2BAA2B;QAC3B,sBAAsB;QACtB,gBAAgB;QAChB,kBAAkB;QAClB,yCAAyC;QACzC,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,cAAc;QACd,6CAA6C;QAC7C,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;;IAEA;;QAEI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;QACvB,qBAAqB;IACzB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;QACtB,+CAA+C;IACnD;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,oBAAoB;QACpB,sBAAsB;QACtB,+CAA+C;IACnD;AACJ;;AAEA;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,yBAAyB;IAC7B;AACJ","sourcesContent":[".header,\r\n.container,\r\n.nav {\r\n    box-shadow: none;\r\n    border: none;\r\n}\r\n\r\n.header {\r\n    width: 100%;\r\n    background-color: #00000000;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1000;\r\n}\r\n\r\n.container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 10px 20px;\r\n    max-width: 100%;\r\n    margin: auto;\r\n}\r\n\r\n.logo {\r\n    width: 120px;\r\n}\r\n\r\n.nav {\r\n    float: right;\r\n    align-items: center;\r\n    margin-top: 15px;\r\n}\r\n\r\n.nav ul {\r\n    display: flex;\r\n    margin-right: 20px;\r\n}\r\n\r\n.nav_bar_button {\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n    color: #ffffff;\r\n    text-decoration: none;\r\n    margin-right: 20px;\r\n    position: relative;\r\n    border: none;\r\n    background: none;\r\n    transition: color 400ms cubic-bezier(0.25, 0.8, 0.25, 1);\r\n}\r\n\r\n.nav_bar_button:focus:after,\r\n.nav_bar_button:hover:after {\r\n    width: 100%;\r\n    left: 0%;\r\n}\r\n\r\n.nav_bar_button:after {\r\n    content: \"\";\r\n    pointer-events: none;\r\n    bottom: -2px;\r\n    left: 50%;\r\n    position: absolute;\r\n    width: 0%;\r\n    height: 2px;\r\n    background-color: #ffffff;\r\n    transition: width 400ms cubic-bezier(0.25, 0.8, 0.25, 1), left 400ms cubic-bezier(0.25, 0.8, 0.25, 1);\r\n}\r\n\r\n.nav_bar_button a {\r\n    color: inherit;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .container {\r\n        padding: 10px 15px;\r\n    }\r\n\r\n    .logo {\r\n        margin-top: 5px;\r\n        width: 80px;\r\n    }\r\n\r\n    .nav ul {\r\n        display: none;\r\n        position: absolute;\r\n        right: -15px;\r\n        width: 200px;\r\n        background-color: #ffffffdd;\r\n        flex-direction: column;\r\n        list-style: none;\r\n        border-radius: 8px;\r\n        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n        margin-left: 0;\r\n    }\r\n\r\n    .nav ul.showMenu {\r\n        display: flex;\r\n    }\r\n\r\n    .nav_bar_button {\r\n        margin: 10px 15px;\r\n        font-size: 14px;\r\n        color: #1e1e1e;\r\n        transition: background-color 0.3s, color 0.3s;\r\n        padding: 8px 15px;\r\n        border-radius: 8px;\r\n    }\r\n\r\n    .nav_bar_button a {\r\n        color: inherit;\r\n    }\r\n\r\n    .nav_bar_button:hover,\r\n    .nav_bar_button:focus {\r\n        background-color: #f4f4f4;\r\n        color: #1e1e1e;\r\n    }\r\n\r\n    .hamburger {\r\n        height: 40px;\r\n        width: 40px;\r\n        transform: 0.2s;\r\n        position: relative;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .hamburger input[type='checkbox'] {\r\n        position: absolute;\r\n        opacity: 0;\r\n        height: 100%;\r\n        width: 100%;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .line {\r\n        transition: 0.5s;\r\n        stroke-width: 4px;\r\n        stroke: #ffffff;\r\n    }\r\n\r\n    .lineTop {\r\n        stroke-dasharray: 40 40;\r\n        stroke-dashoffset: 25;\r\n    }\r\n\r\n    .lineBottom {\r\n        stroke-dasharray: 40 40;\r\n        stroke-dashoffset: 60;\r\n    }\r\n\r\n    .lineMid {\r\n        stroke-dasharray: 40 40;\r\n    }\r\n\r\n    .hamburger input[type='checkbox']:checked+svg .line {\r\n        stroke: #ffffff;\r\n    }\r\n\r\n    .hamburger input[type='checkbox']:checked+svg .lineTop {\r\n        stroke-dashoffset: 0;\r\n        transform-origin: left;\r\n        transform: rotateZ(45deg) translate(-7px, -5px);\r\n    }\r\n\r\n    .hamburger input[type='checkbox']:checked+svg .lineMid {\r\n        stroke-dashoffset: 40;\r\n    }\r\n\r\n    .hamburger input[type='checkbox']:checked+svg .lineBottom {\r\n        stroke-dashoffset: 0;\r\n        transform-origin: left;\r\n        transform: rotateZ(-45deg) translate(-5px, 5px);\r\n    }\r\n}\r\n\r\n@media (min-width: 769px) {\r\n    .container {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n    }\r\n\r\n    .logo {\r\n        order: 1;\r\n    }\r\n\r\n    .nav {\r\n        order: 2;\r\n    }\r\n\r\n    .nav ul {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_homepage_header__r9oVG`,
	"container": `header_homepage_container__upHY-`,
	"nav": `header_homepage_nav__6Fv7q`,
	"logo": `header_homepage_logo__7PTq6`,
	"nav_bar_button": `header_homepage_nav_bar_button__2lzgU`,
	"showMenu": `header_homepage_showMenu__vmxeO`,
	"hamburger": `header_homepage_hamburger__HiVS6`,
	"line": `header_homepage_line__HJ+Xj`,
	"lineTop": `header_homepage_lineTop__1H3YV`,
	"lineBottom": `header_homepage_lineBottom__31-mP`,
	"lineMid": `header_homepage_lineMid__-FPAn`
};
export default ___CSS_LOADER_EXPORT___;
